'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';

const HelpTooltip = (_ref) => {
  let {
    title
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["title"]);

  return /*#__PURE__*/_jsx(UIHelpIcon, {
    title: title,
    className: "m-left-1",
    tooltipProps: Object.assign({
      use: 'longform'
    }, otherProps)
  });
};

HelpTooltip.propTypes = {
  title: PropTypes.node.isRequired
};
export default HelpTooltip;